import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import PaymentDataGrid from './components/payment-data-grid';
import PaymentExportButton from './components/payment-export';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';
import { setIsLoading } from 'slices/loadingSlice';
import PaymentConstants from './constants';
import { handleError } from 'utils/helpers';
import { exportPayment } from 'services/payment.service';
import { toast } from 'react-toastify';

const Payment: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const paymentSearchForm = useAppSelector(
        (state: RootState) => state.payment.paymentsSearchForm
    );

    const userInfo = useAppSelector((state: RootState) => state.user);
    const userRole = React.useMemo(() => userInfo.attributes.role, [userInfo]);

    const handleExport = async () => {
        try {
            dispatch(setIsLoading(true));
            const params = { ...paymentSearchForm };
            if (
                paymentSearchForm.paymentType?.includes(
                    PaymentConstants.type.ALL
                )
            ) {
                params.paymentType = [];
            }
            if (
                paymentSearchForm.status?.includes(PaymentConstants.status.ALL)
            ) {
                params.status = [];
            }
            const excelData = await exportPayment({
                q: {
                    search_with_key_cont: params.searchKeyWord,
                    status_in: params.status?.join(','),
                    product_type_in: params.paymentType?.join(','),
                    start_date: params.startDate,
                    end_date: params.endDate,
                },
            });
            // Get the filename from Content-Disposition header if available
            const filename = 'payments.xlsx';

            // Create blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([excelData]));
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                dispatch(setIsLoading(false));
            }, 100);
        } catch (error) {
            handleError(error);
            dispatch(setIsLoading(false));
        }
    };

    const [searchParams] = useSearchParams();
    const transactionStatus = searchParams.get('vnp_TransactionStatus');

    useEffect(() => {
        if (transactionStatus === '00') {
            toast.success('Thanh toán thành công');
        } else if (transactionStatus) {
            toast.error('Thanh toán thất bại!');
        }
    }, [transactionStatus]);
    return (
        <Box mt={5}>
            <Box mb={'40px'}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="end"
                >
                    <Typography
                        variant="h3"
                        component="h3"
                        fontSize={28}
                        fontWeight={'bold'}
                        lineHeight={'34px'}
                        color={theme.palette.primary.main}
                    >
                        Thanh toán
                    </Typography>

                    <Stack direction="row" spacing={2}>
                        {userRole !== 'client' && (
                            <Button
                                onClick={() => navigate('/admin/payment/add')}
                                sx={{
                                    minWidth: '230px',
                                    fontSize: '20px',
                                    textTransform: 'none',
                                    fontWeight: '700',
                                    lineHeight: '24.2px',
                                    borderRadius: '39.06px',
                                }}
                                variant="contained"
                                startIcon={
                                    <AddIcon
                                        sx={{ fontSize: '40px !important' }}
                                    />
                                }
                            >
                                Thêm mới
                            </Button>
                        )}

                        <PaymentExportButton onClick={handleExport} />
                    </Stack>
                </Box>
            </Box>
            <Card
                elevation={0}
                sx={{
                    borderRadius: '26px',
                }}
            >
                <CardContent
                    sx={{
                        padding: 0,
                        paddingBottom: '0 !important',
                    }}
                >
                    <PaymentDataGrid />
                </CardContent>
            </Card>
        </Box>
    );
};

export default Payment;
